module.exports = __webpack_public_path__ + "img/abdi-white.7d78d8a3.png";